// @ts-nocheck
/* eslint-disable */
export const addCircleSolidIcon = {
    data: `<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="12" cy="12" r="11.2" fill="currentColor" stroke="currentColor" stroke-width="1.6"/><path d="M16.3672 10.7656V12.4609H8.57031V10.7656H16.3672ZM13.3828 7.57812V15.8594H11.5625V7.57812H13.3828Z" fill="white"/></svg>`,
    name: 'add-circle-solid' as const
};